module.exports = __webpack_public_path__ + "static/media/image-coming-soon.ed73ca14.svg";